import { Subject } from "rxjs"
import { SagaPayload } from "./types"

export const sagaSource = new Subject<SagaPayload>()
